import { toast } from "react-toastify";

import DischargeSummaryService from "../../../services/DischargeSummaryService";

// Full tenant auth headers — the discharge-summary service reads the same set of
// sessionStorage keys the doctor console builds (see PatientDetailsPanel.js).
function authHeaders() {
  return {
    Authorization: `Bearer ${sessionStorage.getItem("accessToken") || ""}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
  };
}

/**
 * Open the finalized discharge-summary PDF — the "Finalize" output stored in S3 —
 * in a new tab, fetched as a short-lived presigned URL.
 *
 * Extracted from PatientListView so the billing war room and the nurse dashboard
 * behave identically. Both of those needed it: billing is *blocked* by the
 * summary and had no way to read it, and the nurse physically hands it to the
 * patient with no view of it anywhere.
 *
 * `found: false` means the summary was never finalized for this admission. That
 * is an ordinary answer, not an error, so it informs rather than alarms. Never
 * rejects — callers use it directly as a click handler.
 */
export async function viewFinalizedSummary(admissionId) {
  try {
    const res = await DischargeSummaryService.getDischargePdfUrl(admissionId, authHeaders());
    if (res?.found && res?.url) {
      window.open(res.url, "_blank", "noopener,noreferrer");
    } else {
      toast.info(res?.message || "No finalized discharge summary found for this patient.");
    }
  } catch (err) {
    console.error("Failed to fetch discharge summary PDF:", err?.message);
    toast.error(err?.response?.data?.message || "Could not open the discharge summary.");
  }
}

export default viewFinalizedSummary;
